import { Application } from 'api-paths-cas';
import _ from 'lodash';

// prunes level 1 attributes not in the attributes list, and also removes fields we do not want to track changes for
// such as initiallySubmittedApplication and routeStatus.
const pruneApplicationData = (data: Application) => {
  const prunedData = { ...data };

  delete prunedData.initiallySubmittedApplication;
  delete prunedData.routeStatus;
  delete prunedData.applicationStatus;
  delete prunedData.submittedAt;
  delete prunedData.submittedBy;
  delete prunedData.firstApplicationStatus;
  delete prunedData.agentAccessStatus;

  return prunedData;
};

/**
 * Get application data for specified attributes from both initial and current application states.
 * Handles support for data processed before the `initiallySubmittedApplication` field was added.
 *
 * returned fields may be nested via --> [['programme', 'mode'], 'applicationStatus'].
 * returned entries are of type unknown.
 */
export function getApplicationData(application: Application): {
  initial: Application;
  current: Application;
} {
  // if we do not have initially submitted data, we assume application (support for legacy applications)
  let initialApplicationData = application.initiallySubmittedApplication;
  let currentApplicationData = application;

  currentApplicationData = pruneApplicationData(currentApplicationData);

  if (!initialApplicationData) {
    // for legacy applications we just return current for both initial and current
    // since no initial application is stored
    return { current: currentApplicationData, initial: currentApplicationData };
  }

  initialApplicationData = pruneApplicationData(initialApplicationData);

  return { current: currentApplicationData, initial: initialApplicationData };
}
